// extracted by mini-css-extract-plugin
module.exports = {"error":"LoginAddItem_error__XB666"};